__turbopack_context__.v({
  "description": "BinaryText-module__VxtKWq__description",
  "descriptionParagraph": "BinaryText-module__VxtKWq__descriptionParagraph",
});
